import React from 'react';

import { UserSubscriptionProvider } from './resources/user/subscription/useUserSubscription';

export function ReactQuerySubscriptions({ children }: { children: React.ReactNode }) {
  return <UserSubscriptionProvider>{children}</UserSubscriptionProvider>;
}
